import { IBranch, IDatahubCase, IDatahubOrderLine, IDatahubTask, ISimplifiedOrder, TaskStatus } from 'api';

const isProdLikeEnv =
  import.meta.env.VITE_DEPLOYMENT_ENV === 'production' || import.meta.env.VITE_DEPLOYMENT_ENV === 'qa';

const routes = {
  dashboard: () => '/',
  newOrder: () => '/v1/new-order',
  receipt: ({ orderId, caseId }: { orderId: ISimplifiedOrder['id']; caseId: IDatahubCase['id'] }) =>
    `/v1/receipt?orderId=${orderId}&caseId=${caseId}`,
  activeDirectory: () => '/active-directory',
  login: () => '/login',
  acceptInvite: () => '/accept-invite',
  presentation: (caseId: IDatahubCase['id'], filter: string) => `/presentation?caseId=${caseId}&filter=${filter}`,
  users: () => '/users',
  authRedirect: () => '/auth-redirect',
  booking: () => '/booking',
  interview: () => '/interview',
  systemNotification: () => '/system-notification',
  redirectNewOrderForCase: () => '/redirect/new-order-for-case',
  feedback: ({
    caseId,
    orderId,
    orderlineId,
    vendorOrderLineId,
  }: {
    caseId: IDatahubCase['id'];
    orderId: ISimplifiedOrder['id'];
    orderlineId: IDatahubOrderLine['id'];
    vendorOrderLineId: IDatahubOrderLine['vendorOrderLineId'];
  }) =>
    `/v1/feedback?caseId=${caseId}&orderId=${orderId}&vendorOrderLineId=${vendorOrderLineId}&orderlineId=${orderlineId}`,
  cases: {
    list: () => '/cases',
    view: (id: IDatahubCase['id'], clientId: IBranch['axCustomerId']) =>
      `/cases/${encodeURIComponent(id)}?clientId=${clientId}`,
    details: (id: IDatahubCase['id']) => `/cases/${encodeURIComponent(id)}/details`,
    viewOrder: (caseId: IDatahubCase['id'], orderId: ISimplifiedOrder['id']) =>
      `/cases/${encodeURIComponent(caseId)}/orders?orderId=${orderId}`,
  },
  tasks: {
    list: (query?: string, statuses?: TaskStatus[]) => {
      let url = 'v1/tasks';

      if (query) {
        url += `?query=${query}`;
      }

      if (statuses && statuses.length > 0) {
        if (query) url += '&';
        else url += '?';

        url += statuses.map(status => `status[]=${status}`).join('&');
      }
      return url;
    },
    view: (id: IDatahubTask['id']) => `v1/tasks/${id}`,
  },
  support: () => '/support',
  externalLinks: {
    shine: () => (isProdLikeEnv ? 'https://shine.esoft.com' : 'https://connect-testing.esoft.com'),
    shineLogin: ({ token }: { token: string }) =>
      isProdLikeEnv
        ? `https://shine.esoft.com/login/redirect?code=''&id_token=${token}`
        : `https://connect-testing.esoft.com/login/redirect?code=''&id_token=${token}`,
    esoft: () => 'http://esoft.dk',
  },

  //v2 booqly 2.0
  v2: {
    login: '/login',
    dashboard: '/',
    activeDirectory: '/active-directory',
    authRedirect: '/auth-redirect',
    tasks: {
      overview: '/tasks',
    },
    cases: {
      overview: '/cases',
      detail: '/cases/:id',
      detailForRedirect: '/cases/:id/details',
      orders: '/cases/:id/orders',
      orderDetail: '/cases/:id/orders/:orderId',
    },
    campaigns: {
      overview: '/campaigns',
    },
    helpCenter: '/help-center',
    presentation: (caseId: string) => `/presentation?caseId=${caseId}`,
    order: {
      detail: '/order/:id',
      adsOrder: '/order/create-order/ads',
      newOrder: '/order/new-order',
    },
    accountSettings: {
      overview: '/account-settings',
      helpCenter: '/account-settings?tab=help-center',
      branchSetting: '/account-settings?tab=branch',
    },
    interview: '/interview',
    booking: '/booking',
    questionnaire: '/questionnaire',
  },
};

// TODO: refactor and improve routes as params and router strings
// simplified map for router
routes.feedback.toString = () => '/v1/feedback';
routes.presentation.toString = () => '/presentation';
routes.receipt.toString = () => '/v1/receipt';
routes.tasks.toString = () => '/v1/tasks';
routes.cases.view.toString = () => '/cases/:id';
routes.cases.details.toString = () => '/cases/:id/details';
routes.cases.viewOrder.toString = () => '/cases/:id/orders';

export default routes;
